import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { CheckCircle2, Youtube, Linkedin, Facebook } from 'lucide-react';

const Foredrag = () => {
  const topics = [
    "Optimering af pension",
    "Optimering af realkreditlån",
    "Samspillet mellem efterløn og pension",
    "Hvad skal jeg være opmærksom på, såfremt jeg ønsker at skifte bank?",
    "Iværksættere, hvordan kommer jeg i gang med selvstændig virksomhed?",
    "Optimering af din virksomhed",
    "Optimering af skat",
    "Investering – hvordan kommer jeg i gang med at investere?",
    "Obligationer og aktier samt investeringsbeviser – hvad er forskellen?",
    "Investering for frie midler, pensionsmidler samt virksomhedsmidler"
  ];

  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Foredrag: Økonomiske foredrag til private og virksomheder</title>
        <meta name="description" content="Som uvildige økonomiske rådgivere tilbyder vi foredrag om økonomiemner efter jeres ønske, uanset om det er privat eller erhverv. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Foredrag</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Foredrag</h1>

        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <p>
            Som uvildige rådgivere er vi løbende i kontakt med mange forskellige kundetyper, som ønsker, at vi holder et foredrag inden for et specifikt emne. Det kan være privatpersoner, andelsboligforeninger, virksomhedsledere/-ejere, foreninger m.fl.
          </p>
          <p>
            Spørgsmålene er ofte mange og forskelligartede, men fælles for henvendelserne er søgen efter viden og optimale løsninger.
          </p>
          <p>
            Vi sammensætter gerne et individuelt foredrag for jer under hensyntagen til varighed og ønske til emne.
          </p>
        </div>

        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-200 mb-12">
          <h3 className="text-xl font-bold text-slate-900 mb-8">
            Nedenstående emner er blot eksempler, men som nævnt vil udgangspunktet være jeres individuelle ønsker:
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
            {topics.map((topic, i) => (
              <li key={i} className="flex items-start">
                <CheckCircle2 size={20} className="text-[#b60f00] mr-3 shrink-0 mt-1" />
                <span className="text-slate-700 leading-relaxed">{topic}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="prose prose-slate prose-lg max-w-none mb-12">
          <p>
            I kan også følge med på vores <a href="http://www.youtube.com/c/FinansoptimeringDK" target="_blank" rel="noopener noreferrer" className="text-[#b60f00] hover:underline inline-flex items-center">YouTube kanal <Youtube size={18} className="ml-1" /></a>, hvor vi jævnligt tager fat i relevante økonomiske emner. Har I et emne, som I kunne tænke jer, at vi laver en kort video om, så kontakt os via linket herunder. I kan også løbende tilmelde jer vores forskellige events med foredrag om bl.a. investering, skat og økonomisk optimering. Vi gør altid opmærksom på vores events i god tid på <Link to="/blog" className="text-[#b60f00] hover:underline">bloggen</Link>, vores <a href="https://www.linkedin.com/company/4976772" target="_blank" rel="noopener noreferrer" className="text-[#b60f00] hover:underline">LinkedIn side</a> og vores <a href="https://www.facebook.com/finansoptimering" target="_blank" rel="noopener noreferrer" className="text-[#b60f00] hover:underline">Facebook side</a>.
          </p>
        </div>

        <div className="text-center">
          <Link 
            to="/kontakt-os" 
            className="inline-flex items-center bg-[#b60f00] text-white px-10 py-5 rounded-2xl text-lg font-bold hover:bg-[#a00d00] transition-all shadow-lg hover:shadow-red-200 active:scale-95"
          >
            Bestil en gratis uforpligtende samtale, og hør mere om mulighederne for et foredrag
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Foredrag;
